import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiQuery } from '../../../../common/model/api.query';
import { users } from '../model/user.fragments';
import { UserOutput } from '../model/user.output';

@Injectable({ providedIn: 'root' })
export class FetchCoachCoacheesApiQuery extends ApiQuery<UserOutput[], void> {
	client = 'iam';
	document = gql`
		query FetchCoachCoachees {
			fetchCoachCoachees {
				...Users
			}
		}
		${users}
	`;
	method = 'fetchCoachCoachees';
}
